import script from "./PlayerTennisNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerTennisNew.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__